const HTML_FILE_REGEXP = /[^/]*\.html$/gi

export function extractUrlFromCssBackgroundImage(input?: string): string | null {
  if (!input) return null
  if (!input.startsWith('url(')) return input
  const regex = /url\(['"]?(.*?)['"]?\)/
  const match = regex.exec(input)
  return match ? match[1] : null
}

export function stripQueryParams(url = ''): string {
  const index = url.indexOf('?')
  return index === -1 ? url : url.slice(0, index)
}

export function isValidUrl(urlString: string) {
  const urlPattern = new RegExp(
    '^(https?:\\/\\/)?' + // validate protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // validate domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // validate OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+:]*)*' + // validate port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // validate query string
      '(\\#[-a-z\\d_]*)?$', // validate fragment
    'i',
  )
  return !!urlPattern.test(urlString)
}

export function extractBaseUrlAndResource(urlString?: string | null): [string, string] {
  if (!urlString) return ['', '']
  try {
    const urlObj = new URL(urlString)
    const pathWithoutHtml = urlObj.pathname.replace(HTML_FILE_REGEXP, '')
    let htmlFile = urlObj.pathname.match(HTML_FILE_REGEXP)?.[0] ?? ''
    if (urlObj.hash) htmlFile += urlObj.hash
    return [`${urlObj.origin}${pathWithoutHtml}`, htmlFile]
  } catch (e) {
    return ['', '']
  }
}

export function extractBaseUrl(urlString?: string | null): string {
  return extractBaseUrlAndResource(urlString)[0]
}

export function extractResource(urlString?: string | null): string {
  return extractBaseUrlAndResource(urlString)[1]
}

export function enforceHttps(url: string): string {
  let secureUrl = url.trim().replace(/^https?:\/\//i, 'https://')
  if (!secureUrl.startsWith('https://')) {
    secureUrl = 'https://' + secureUrl
  }
  return secureUrl
}
